import {h, Fragment} from "preact"
import { useEffect } from "preact/hooks";
import { useFacet, useProductFilters, useAppState } from "@nosto/preact"
import Checkbox from "./elements/Checkbox"
import { CheckboxColor, CheckboxSize } from "./elements/CustomCheckbox"
import { filterColorMapping } from "../helpers"
import Icon from "./elements/Icon"

export default function Facet({ facet }) {
    const { active, selectedFiltersCount, toggleActive, toggleProductFilter } = useFacet(facet)
    const { filters, removeAll } = useProductFilters()
    const {
        response: { query }
    } = useAppState()

    useEffect(() => {
        // Check if the facet is "color" 
        if (facet.name.toString().toLowerCase() === "color") {
            const activeColorFilters = filters
                .filter(filter => filter.field === facet.field)
                .map(filter => filter.value);
    
            if (activeColorFilters.length === 1) {
                // Run filterColorMapping for the single active color filter
                filterColorMapping(activeColorFilters[0]?.trim());
            }
    
            // Define available colors as array
            const availableColors = [
                "Black", "Grey", "Yellow", "Green", "Red", "Blue", 
                "White", "Orange", "Pink", "Purple", "Brown", 
                "Khaki", "Multi"
            ];
    
            // Check if query contains any color names
            if (query) {
                const lowerQuery = query.toLowerCase();
                
                // Check if query contains any of our available colors
                for (const color of availableColors) {
                    if (lowerQuery.includes(color.toLowerCase())) {
                        console.log("Found color in query:", color);
                        filterColorMapping(color);
                        break; // Only process the first color match
                    }
                }
            }
        }
    }, []);

    if(facet.data.length <= 1) {
        return;
    }

    if(facet.name.toString().toLowerCase() == "color") {
        let colors = {
            "Black": "#000000", 
            "Grey": "#afb3b6", 
            "Yellow": "#f7e299",
            "Green": "#74b795",
            "Red": "#b55258",
            "Blue": "#6ea3d5",
            "White": "#ffffff",
            "Orange": "#f8a079",
            "Pink": "#cd849e",
            "Purple": "#c0b6cf",
            "Brown": "#98714e",
            "Khaki": "#b2a288",
            "Multi": "unset"
        }

        return (
            <li class={`ns-sidebar-dropdown facets ${active ? "ns-active" : ""}`}>
                <a
                    class="ns-d-inline-block ns-relative ns-w-100 ns-border-box ns-text-undecorated filter-headers"
                    href="javascript:void(0)"
                    data-nosto-element="facet"
                    onClick={toggleActive}
                >
                    <span class="ns-color-black ns-font-4 ns-text-uppercase filter-heading">{facet.name}</span>
                    <Icon name="plusminus" className="ns-absolute" />
                </a>
                <div class="ns-sidebar-submenu ns-d-none ns-py-4">
                    <ul class="ns-list-unstyled ns-p-0 ns-m-0 swatches">
                        {facet.data?.map(value => (
                            <li
                                class="ns-d-flex ns-justify-content-between ns-align-items-center ns-font-3"
                                data-nosto-element="facet-setting"
                            >
                                <CheckboxColor
                                    value={value.value.trim()}
                                    selected={value.selected}
                                    bgColor={colors[value.value.trim()]}
                                    onChange={e => {
                                        e.preventDefault()
                                        console.log("value.value: ", value.value)
                                        console.log("value.value.trim(): ", value.value.trim())
                                        toggleProductFilter(facet.field, value.value, !value.selected).then(() => {filterColorMapping(value.value.trim())})
                                    }}
                                />
                            </li>
                        ))}
                    </ul>
                </div>
            </li>
        )
    } else if(facet.name.toString().toLowerCase() == "sizes" || facet.name.toString().toLowerCase() == "size") {
        const alphaOrder = ["1SZ", "XXS", "XXS/XS", "XS","XS/S", "S", "S/M", "M", "M/L", "L", "L-Long", "XL", "XL/XXL", "XXL", "XXL/XXXL"],
              numericOrder = ["00", "0", "1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50"],
              alphaNumericOrder = [];
              
        let alphaSizes = [],
            numericSizes = [],
            alphaNumericSizes = [];
        
        let itemOrder = "";

        facet.data?.map(value => {
            if(alphaOrder.includes(value.value)) {
                alphaSizes.push(value)
            } else if(numericOrder.includes(value.value)) {
                numericSizes.push(value)
            } else {
                alphaNumericSizes.push(value)
            }
        })

        return (
            <li class={`ns-sidebar-dropdown facets ${active ? "ns-active" : ""}`}>
                <a
                    class="ns-d-inline-block ns-relative ns-w-100 ns-border-box ns-text-undecorated filter-headers"
                    href="javascript:void(0)"
                    data-nosto-element="facet"
                    onClick={toggleActive}
                >
                    <span class="ns-color-black ns-font-4 ns-text-uppercase filter-heading">{facet.name}</span>
                    <Icon name="plusminus" className="ns-absolute" />
                </a>
                <div class="ns-sidebar-submenu ns-d-none ns-py-4">
                    { alphaSizes.length > 0 && (
                        <>
                            <span class="ns-color-black ns-font-4 ns-text-uppercase filter-heading ns-pt-4 filter-subheader">Alpha</span>
                            <ul class="ns-list-unstyled ns-p-0 ns-m-0 sizes ns-py-4">
                                {alphaSizes?.map(value => {
                                    itemOrder = alphaOrder.indexOf(value.value);
                                    return (
                                        <li
                                            class="ns-d-flex ns-justify-content-between ns-align-items-center ns-font-3"
                                            data-nosto-element="facet-setting"
                                            style={`order:${itemOrder}`}
                                        >
                                            <CheckboxSize
                                                value={value.value}
                                                selected={value.selected}
                                                onChange={e => {
                                                    e.preventDefault()
                                                    toggleProductFilter(facet.field, value.value, !value.selected)
                                                }}
                                            />
                                        </li>
                                    )
                                })}
                            </ul>
                        </>
                    )}
                    { numericSizes.length > 0 && (
                        <>
                            <span class="ns-color-black ns-font-4 ns-text-uppercase filter-heading ns-pt-4 filter-subheader">Numeric</span>
                            <ul class="ns-list-unstyled ns-p-0 ns-m-0 sizes ns-py-4">
                            {numericSizes?.map(value => {
                                itemOrder = numericOrder.indexOf(value.value);
                                return (
                                    <li
                                    class="ns-d-flex ns-justify-content-between ns-align-items-center ns-font-3"
                                    data-nosto-element="facet-setting"
                                    style={`order:${itemOrder}`}
                                    >
                                    <CheckboxSize
                                        value={value.value}
                                        selected={value.selected}
                                        onChange={e => {
                                            e.preventDefault()
                                            toggleProductFilter(facet.field, value.value, !value.selected)
                                        }}
                                    />
                                    </li>
                                )
                            })}
                            </ul>
                        </>
                    )}
                    { alphaNumericSizes.length > 0 && (
                        <>
                            <span class="ns-color-black ns-font-4 ns-text-uppercase filter-heading ns-pt-4 filter-subheader">Alpha Numeric</span>
                            <ul class="ns-list-unstyled ns-p-0 ns-m-0 sizes ns-py-4">
                            {alphaNumericSizes?.map(value => {
                                itemOrder = ""
                                return (
                                    <li
                                    class="ns-d-flex ns-justify-content-between ns-align-items-center ns-font-3"
                                    data-nosto-element="facet-setting"
                                    style={`order:${itemOrder}`}
                                    >
                                    <CheckboxSize
                                        value={value.value}
                                        selected={value.selected}
                                        className="alphaNumericSizes"
                                        onChange={e => {
                                            e.preventDefault()
                                            toggleProductFilter(facet.field, value.value, !value.selected)
                                        }}
                                    />
                                    </li>
                                )
                            })}
                            </ul>
                        </>
                    )}
                </div>
            </li>
        )
    }

    return (
        <li class={`ns-sidebar-dropdown facets ${active ? "ns-active" : ""}`}>
            <a
                class="ns-d-inline-block ns-relative ns-w-100 ns-border-box ns-text-undecorated filter-headers"
                href="javascript:void(0)"
                data-nosto-element="facet"
                onClick={toggleActive}
            >
                <span class="ns-color-black ns-font-4 ns-text-uppercase filter-heading">{facet.name}</span>
                {/* {selectedFiltersCount > 0 && (
                    <span class="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                        {selectedFiltersCount}
                    </span>
                )} */}
                <Icon name="plusminus" className="ns-absolute" />
            </a>
            <div class="ns-sidebar-submenu ns-d-none ns-py-4">
                <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                    {facet.data?.map(value => (
                        <li
                            class="ns-d-flex ns-justify-content-between ns-align-items-center ns-font-3"
                            data-nosto-element="facet-setting"
                        >
                            <Checkbox
                                value={value.value}
                                selected={value.selected}
                                onChange={e => {
                                    e.preventDefault()
                                    toggleProductFilter(facet.field, value.value, !value.selected)
                                }}
                            />
                        </li>
                    ))}
                </ul>
            </div>
        </li>
    )
}
